import { all } from 'redux-saga/effects';
import scenesSaga from './scenesSaga';
import downloadingSaga from './downloadingSaga';
import alertSaga from './alertSaga';
import ratioFormatSaga from './ratioFormatSaga';
import audioSaga from './audioSaga';
import { userSaga } from 'modules/sagas/userSaga';
import effectsSaga from './effectsSaga';
import activeToolSaga from './activeToolSaga';
import settingsSaga from './settingsSaga';
import templatesSaga, { loadTemplates } from './templatesSaga';
import transitionSaga from './transitionSaga';
import scenesLoaderSaga from 'modules/sagas/scenesLoaderSaga';
import projectFilesSaga from './projectFilesSaga';
import revisionsSaga from './revisionsSaga';
import oneTimePaymentSaga from './oneTimePaymentSaga';
import { put } from 'redux-saga-test-plan/matchers';
import { fetchSettings } from 'modules/settings';
import { loadTransitions } from 'modules/transitions';
import ErrorLogger from '../../components/ErrorLogger';

function* initApp() {
  yield loadTemplates();

  yield put(fetchSettings());
  yield put(loadTransitions());
}

export default function* rootSaga() {
  try {
    yield all([
      revisionsSaga(),
      scenesSaga(),
      downloadingSaga(),
      alertSaga(),
      ratioFormatSaga(),
      userSaga(),
      effectsSaga(),
      activeToolSaga(),
      audioSaga(),
      settingsSaga(),
      templatesSaga(),
      transitionSaga(),
      scenesLoaderSaga(),
      projectFilesSaga(),
      oneTimePaymentSaga(),
      initApp()
    ]);
  } catch (error) {
    ErrorLogger.trigger(error);
    // eslint-disable-next-line no-console
    console.error(error);
  }
}
